<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import LazyContent from '../UI/Loading/LazyContent.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import ContractRestructuringView from './ContractRestructuringView.vue'

export default {
  components: { ContractRestructuringView, BlockContent, LazyContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    restructurings: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    contractId: {
      type: Number,
      required: false,
      default: null,
    },
  },
}
</script>
<template>
  <LazyContent :loading="loading">
    <BlockContent col-style="col-md-6">
      <h5
        class="mb-0"
        v-html="$t('contract.restructuring.listTitle', { restructuringNumber: restructurings.length })"
      />
    </BlockContent>
    <template v-for="restructuring in restructurings" :key="restructuring.id">
      <ContractRestructuringView :restructuring="restructuring" :contract-id="contractId" :loading="loading" />
    </template>
  </LazyContent>
</template>
